import _ from 'lodash';
import moment from 'moment';

export const MONTH_DAY_YEAR_FORMAT = 'M/D/YYYY';
export const MONTH_DAY_FORMAT = 'MMM D, dddd';
export const MONTH_DATE_FORMAT = 'MMM D';
export const TIME_OF_DAY_FORMAT = 'h:mma';
export const TIME_OF_DAY_WITH_TZ_FORMAT = 'h:mma (zz)';
export const TIME_MONTH_DAY_FORMAT = `${TIME_OF_DAY_FORMAT}, ${MONTH_DAY_FORMAT}`;
export const MONTH_DATE_TIME_FORMAT = `${MONTH_DATE_FORMAT}, ${TIME_OF_DAY_FORMAT}`;
export const DATE_TIME_FORMAT_VERBOSE = `${MONTH_DATE_FORMAT} [at] ${TIME_OF_DAY_FORMAT}`;

export const getMaybeArrivalTime = (args: {
  startTime: Date;
  arrivalTime: Date | null;
  timezone?: string;
  arriveTimeFormat?: string;
  hideTimestamp: boolean;
}) => {
  const {
    arrivalTime,
    timezone,
    startTime,
    arriveTimeFormat = TIME_OF_DAY_FORMAT,
    hideTimestamp,
  } = args;
  if (!arrivalTime) return;
  if (moment(startTime).isSame(arrivalTime)) return;
  return `(Arrive: ${formatWithMaybeTimeZone({
    time: arrivalTime,
    format: hideTimestamp ? MONTH_DATE_FORMAT : arriveTimeFormat,
    timezone,
  })})`;
};

export const getStartAndArrivalTime = (args: {
  startTime: Date;
  arrivalTime: Date | null;
  timezone?: string;
  startTimeFormat?: string;
  arriveTimeFormat?: string;
  showArrivalTimeOnly: boolean;
  hideTimestamp: boolean;
}) => {
  const {
    startTime,
    arrivalTime,
    timezone,
    startTimeFormat = DATE_TIME_FORMAT_VERBOSE,
    showArrivalTimeOnly,
    hideTimestamp,
  } = args;
  const startTimeString = formatWithMaybeTimeZone({
    time: showArrivalTimeOnly && arrivalTime ? arrivalTime : startTime,
    format: hideTimestamp ? MONTH_DATE_FORMAT : startTimeFormat,
    timezone,
  });
  if (showArrivalTimeOnly) return startTimeString;
  const arriveTimeString = getMaybeArrivalTime(args);

  return _.compact([startTimeString, arriveTimeString]).join(' ');
};

const formatWithMaybeTimeZone = (args: {
  time: Date;
  format: string;
  timezone?: string;
}) => {
  const { time, format, timezone } = args;
  if (timezone) return moment(time).tz(timezone).format(format);
  return moment(time).format(format);
};
